<template>
  <section class="intro">
    <div class="container">
      <div class="introbox">
        <ul class="ibnav">
          <li :class="{active: tab==0}">
            <em></em>
            <div class="ibnin">
              <span class="title">Pay per Video</span>
              <span class="subtitle">Watch videos individually and pay only for what you use.</span>
            </div>
            <a href="" class="wlink" v-on:click.prevent="tab=0"></a>
          </li>
          <li :class="{active: tab==1}">
            <em></em>
            <div class="ibnin">
              <span class="title">PAY PER GROUP OF VIDEOS</span>
              <span class="subtitle">Watch entire groups of videos with Kathi's monthly packages.</span>
            </div>
            <a href="" class="wlink" v-on:click.prevent="tab=1"></a>
          </li>
          <li :class="{active: tab==2}">
            <em></em>
            <div class="ibnin">
              <span class="title">PPATT TRAINING VIDEOS</span>
              <span class="subtitle">As a PPATT student, review your training sessions exclusively.</span>
            </div>
            <a href="" class="wlink" v-on:click.prevent="tab=2"></a>
          </li>
        </ul>
        <ul class="ibitems">
          <li v-show="tab==0">
            <img src="temp/tab2.jpg" />
            <div class="over">
              <div class="join">
                <div class="jprice">
                  <span class="stf">starting from</span>
                  <div>
                    $29<sup>,00</sup>
                    <span>/mo</span>
                  </div>
                </div>
                <router-link :to="{name: 'packages'}" class="jbtn">Join Now!</router-link>
              </div>
            </div>
          </li>
          <li v-show="tab==1">
            <img src="temp/tab1.jpg" />
            <div class="over">
              <div class="join">
                <div class="jprice">
                  <span class="stf">starting from</span>
                  <div>
                    $29<sup>,00</sup>
                    <span>/mo</span>
                  </div>
                </div>
                <router-link :to="{name: 'packages'}" class="jbtn">Join Now!</router-link>
              </div>
            </div>
          </li>
          <li v-show="tab==2">
            <img src="temp/tab3.jpg" />
            <div class="over">
              <div class="join">
                <div class="jprice">
                  <span class="stf">starting from</span>
                  <div>
                    $29<sup>,00</sup>
                    <span>/mo</span>
                  </div>
                </div>
                <router-link :to="{name: 'packages'}" class="jbtn">Join Now!</router-link>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data: ()=>({
    tab: 0,
  }),
}
</script>
